// Tri « naturel » : les nombres sont comparés par valeur (« 2 » avant « 10 »),
// accents et casse ignorés.
const collator = new Intl.Collator("fr", {
  numeric: true,
  sensitivity: "base",
});

export function naturalCompare(
  a: string | null | undefined,
  b: string | null | undefined,
): number {
  return collator.compare(a ?? "", b ?? "");
}
